export default {
  state: {
    payStatus: 'select', // payStatus select paying payend
    payIngStatus: '', // ing ==> loading || before-end ==> '' || end ==> ''
    payEndStatus: '', // success || fail || noGoods(暂无商品)
    payWay: '',
    orderObj: {},
    cashierConfig: {},
  },
  mutations: {
    updateOrder(state, orderObj) {
      state.orderObj = orderObj;
    },
    updatePayStatus(state, payStatus) {
      state.payStatus = payStatus;
    },
    updatePayWay(state, payWay) {
      state.payWay = payWay;
    },
    updatePayIngStatus(state, payIngStatus) {
      state.payIngStatus = payIngStatus;
    },
    updatePayEndStatus(state, payEndStatus) {
      state.payEndStatus = payEndStatus;
    },
    updataCashierConfig(state, cashierConfig) {
      state.cashierConfig = cashierConfig;
    },
  },
};
